'use client';

import { c as _c } from "react/compiler-runtime";
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { useCallback, useEffect, useRef, useState } from 'react';
const DEFAULT_AUTO_CLOSE_DELAY = 1000;
interface UseAutoCloseCollapsibleOptions {
  isStreaming: boolean;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  autoCloseDelay?: number;
}
interface UseAutoCloseCollapsibleResult {
  isOpen: boolean;
  handleOpenChange: (open: boolean) => void;
}
export function useAutoCloseCollapsible(t0) {
  const $ = _c(21);
  const {
    isStreaming,
    open,
    defaultOpen: t1,
    onOpenChange,
    autoCloseDelay: t2
  } = t0;
  const defaultOpen = t1 === undefined ? false : t1;
  const autoCloseDelay = t2 === undefined ? DEFAULT_AUTO_CLOSE_DELAY : t2;
  let t3;
  if ($[0] !== defaultOpen || $[1] !== onOpenChange || $[2] !== open) {
    t3 = {
      prop: open,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    };
    $[0] = defaultOpen;
    $[1] = onOpenChange;
    $[2] = open;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [isOpen, setIsOpen] = useControllableState(t3);
  const [hasAutoClosed, setHasAutoClosed] = useState(false);
  const [wasEverStreaming, setWasEverStreaming] = useState(false);
  const userInteractedRef = useRef(false);
  let t4;
  let t5;
  if ($[4] !== isStreaming) {
    t4 = () => {
      if (isStreaming) {
        setWasEverStreaming(true);
      }
    };
    t5 = [isStreaming];
    $[4] = isStreaming;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[7] !== autoCloseDelay || $[8] !== defaultOpen || $[9] !== hasAutoClosed || $[10] !== isOpen || $[11] !== isStreaming || $[12] !== setIsOpen || $[13] !== wasEverStreaming) {
    t6 = () => {
      if (!isStreaming && isOpen && !defaultOpen && !hasAutoClosed && !userInteractedRef.current && wasEverStreaming) {
        const timer = setTimeout(() => {
          setIsOpen(false);
          setHasAutoClosed(true);
        }, autoCloseDelay);
        return () => clearTimeout(timer);
      }
    };
    t7 = [isStreaming, isOpen, defaultOpen, setIsOpen, hasAutoClosed, wasEverStreaming, autoCloseDelay];
    $[7] = autoCloseDelay;
    $[8] = defaultOpen;
    $[9] = hasAutoClosed;
    $[10] = isOpen;
    $[11] = isStreaming;
    $[12] = setIsOpen;
    $[13] = wasEverStreaming;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] !== setIsOpen) {
    t8 = newOpen => {
      userInteractedRef.current = true;
      setIsOpen(newOpen);
    };
    $[16] = setIsOpen;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const handleOpenChange = t8;
  const t9 = isOpen ?? false;
  let t10;
  if ($[18] !== handleOpenChange || $[19] !== t9) {
    t10 = {
      isOpen: t9,
      handleOpenChange
    };
    $[18] = handleOpenChange;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}